import { createFileRoute } from '@tanstack/react-router';
import { CurriculumTab } from '@/features/Trainer/CurriculumTab';

export const Route = createFileRoute('/trainer/batches/$batchId/curriculum')({
  validateSearch: (search: Record<string, unknown>) => ({
    topicId: typeof search.topicId === 'string' ? search.topicId : undefined,
  }),
  component: CurriculumRoute,
});

function CurriculumRoute() {
  const { batchId } = Route.useParams();
  const { topicId } = Route.useSearch();
  return <CurriculumTab batchId={batchId} initialTopicId={topicId} />;
}
